import { Enum } from './enum';
export var SpacingTypes = Enum('compact', 'normal', 'relaxed');
export var DensityType = Enum({
  COMPACT: 'compact',
  NORMAL: 'normal',
  RELAXED: 'relaxed'
});
export var SizeType = Enum({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
});